
interface VacationPriceProps {
  vacation: any;
}

export const VacationPrice = ({ vacation }: VacationPriceProps) => {
  const vacationPrice = vacation.price || null;

  if (!vacationPrice) return null;

  return (
    <div className="text-lg font-bold text-blue-600">
      €{vacationPrice}
      {vacation.priceType && (
        <span className="text-sm font-normal text-gray-500 ml-1">
          {vacation.priceType}
        </span>
      )}
    </div>
  );
};
